// @flow weak

import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import MaybeRedirectOnMount from 'app/common/components/MaybeRedirectOnMount';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    onRedirect(url) {
      return dispatch(routeTo(url));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaybeRedirectOnMount);
